export default function formatPercent(value) {
  if (value == null || String(value).trim() === '') return '—';
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString('id-ID', { maximumFractionDigits: 20 }) + '%'
    : '—';
}
